<template>
    <div class="dialog_wrap" v-if="isShow">
      <div class="dialog-shadow" @click="close"></div>
      <section class="dialog-news">
        <div class="dialog-title">
          <span></span>
          <span class="news-title">公告</span>
          <span class="dialog-close-btn" @click="close">关闭</span>
        </div>
        <div class="dialog-content">
          <div>
            <h3 style="font-weight: 600;">关于不法分子冒用我司名义的情况说明</h3>
            <p>近期我公司盈融达投资（北京）有限公司（以下简称“我司”）（登记编码：P1000405）接到投资者举报，称香港盈达投资有限公司冒用我公司名义开发一款【盈达财富】APP实施诈骗，APP上的公司地址中详细列明我司公司名称及地址，客服联系邮箱命名为yrd889900@163.com。</p>
            <p>
              经我司核查，上述行为系不法分子冒用我司名称，通过互联网方式进行诈骗。我司并未开展或授权任何机构或个人以任何形式从事互联网投资理财业务，任何以我司名义开展的互联网投资理财业务及宣传，均属于诈骗行为。
            </p>
            <p>
              我司完全按照中国证券监督管理委员会、中国证券投资基金业协会的监管要求，合法合规开展业务。为了避免上述针对我司的侵权行为给监管部门的工作带来误导，我司在得知上述侵权行为后，现第一时间向监管部门报备，以维护我司的合法权益。
            </p>
            <p>
              与此同时，我司将会严厉追究不法分子的法律责任，通过法律途径维护我司的合法权益。
            </p>
            <p>特此说明！</p>
            <p style="text-align: right">盈融达投资（北京）有限公司</p>
            <p style="text-align: right">2020年3月25日</p>
<!--            <div class="imgs">-->
<!--              <img :src="src1" >-->
<!--              <img :src="src2" >-->
<!--            </div>-->
          </div>
        </div>
      </section>
    </div>
</template>
<script>
  import src1 from '../../assets/src1.png'
  import src2 from '../../assets/src2.png'
    export default {
        name: 'dialog',
        components: {},

        props: {},

        data() {
            return {
              src1,
              src2,
              isShow:true,//默认显示弹框
              logoWidth: 0,
            }
        },

        computed: {},

        watch: {},

        created() {

        },

        mounted() {
        },

        destroyed() {
        },

        methods: {
          close() {
            this.isShow = false;
          },
        }
    }
</script>

<style scoped lang="scss">
.dialog_wrap{
  .dialog-shadow{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: black;
    opacity: .7;
    z-index: 2;
  }
  .dialog-news{
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    background: white;
    margin: auto;
    width: 60%;
    height: 80%;
    display: flex;
    z-index: 3;
    flex-direction: column;
  }
  .dialog-title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: .5%;
    background: #c8ad6d;
    opacity: .6;
  }
  .dialog-title span{
    color: white;
  }
  .dialog-title span:hover{
    cursor: pointer;
  }
  .dialog-content>div{
    width: 95%;
    margin: auto;
    padding-top: 3%;
  }
  .dialog-content p{
    margin: 2% 0;
    font-size: 1rem;
    line-height: 1.5;
    text-align: justify;
    text-indent: 2%;
  }
  .dialog-content span{
    font-size: .6rem;
  }
  .imgs{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    img{
      margin: 0 1%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/dialog.vue